<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Services
	import { postReq } from '../../../../../services/http';
	//Stores
		import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Slider, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Request } from '../../../../../types/requests/request';
	import type { Device } from '../../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let disabled: boolean;
	export let device: Device;
	export const save = async (): Promise<Request> => {
		if (value == settings.sensitivity) return { isok: true };
		return await postReq(
			`/device/generic_command`,
			{
				id,
				command: `motion_sensitivity`,
				payload: JSON.stringify({ value: Number(value) }),
			},
			10000,
		);
	};

	const id = real_id(device.id),
		settings = $settingsStore.motion,
		min = 1,
		max = 256;

	let value = settings.sensitivity;
	const lineMarkers = [{ value: min }, { value: max }];

	const a11yProps = {
		sliderValueText: $format('current_sensitivity_value', {
			values: { value },
			default: `Current sensitivity value is ${value}`,
		}),
		ariaLabel: $format('label_set_motion_sensitivity', { default: 'Set Motion Sensitivity' }),
		ariaLabelValue: $format('current_sensitivity_value', {
			values: { value },
			default: `Current sensitivity value is ${value}`,
		}),
	};
</script>

<Text
	styleType="body-small"
	class={classMap({
		'mb-xs': true,
		'text-color-3': disabled,
	})}
>
	{$showNewLayout
		? $format('motion_detection_threshold_description_new_layout', {
				default: 'Motion detection threshold. Lower value sets higher sensitivity.',
			})
		: $format('motion_detection_threshold_description', {
				values: { min, max },
				default: `Motion detection threshold (from ${min} to ${max}). Lower value sets higher sensitivity.`,
			})}
</Text>

{#if $showNewLayout}
	<Slider
		id="slider-pw626ut"
		{a11yProps}
		class="mb-m"
		type="incremented"
		step={1}
		trackColor="color-light-gray"
		{lineMarkers}
		unit=""
		{disabled}
		bind:value
		{min}
		{max}
	/>
{:else}
	<Slider
		id="slider-pw626ut"
		{a11yProps}
		class="mb-m"
		type="horizontal"
		unit=""
		{disabled}
		bind:value
		{min}
		{max}
	/>
{/if}
